// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__2KbcN","main":"Footer_main__2183R","names":"Footer_names__343qd","commentMessage":"Footer_commentMessage__2Wk6V","email":"Footer_email__3SReh"};